<template>
  <div v-if="type === 'video'" class="lesson-video-player">
    <vue-plyr ref="plyr">
      <div data-plyr-provider="youtube"
           :data-plyr-embed-id="videoId"
           data-plyr-config='{"youtube": {"hl": "ar"}}'
      ></div>
    </vue-plyr>
  </div>
</template>

<script>
import VuePlyr from 'vue-plyr'
import { nextTick } from 'vue';
import { registerPlaybackPlayer } from '@/services/playbackManager';

import {
  Player,
  Youtube,
  Ui,
  LoadingScreen,
  Controls,
  PlaybackControl,
  VolumeControl,
  SettingsControl,
  ScrubberControl,
  Poster,
  DefaultSettings,
  ClickToPlay,
  FullscreenControl
} from '@vime/vue-next';
import '@/assets/css/default.css';

export default {
  name: "youtube-video",
  props: {
    videoId: String,
    type: String,
  },
  data() {
    return {
      primary_color: "#051629",
      logo: require("@/assets/images/logo.png"),
      isPiP: false,
      playerInstance: null,
      playbackRegistration: null,
      plyrInstance: null,
    };
  },
  components: {
    Player,
    Youtube,
    Ui,
    Controls,
    PlaybackControl,
    VolumeControl,
    SettingsControl,
    ScrubberControl,
    Poster,
    DefaultSettings,
    ClickToPlay,
    LoadingScreen,
    FullscreenControl,
    VuePlyr
  },
  mounted() {
    this.playbackRegistration = registerPlaybackPlayer({
      pause: this.pausePlayer,
    });

    nextTick(() => {
      this.plyrInstance = this.$refs.plyr && this.$refs.plyr.player;
      if (!this.plyrInstance || !this.plyrInstance.on) return;

      this.plyrInstance.on('play', this.onPlaybackStart);
      this.plyrInstance.on('pause', this.onPlaybackPause);
      this.plyrInstance.on('ended', this.onPlaybackPause);
    });
  },
  beforeUnmount() {
    if (this.plyrInstance && this.plyrInstance.off) {
      this.plyrInstance.off('play', this.onPlaybackStart);
      this.plyrInstance.off('pause', this.onPlaybackPause);
      this.plyrInstance.off('ended', this.onPlaybackPause);
    }

    if (this.playbackRegistration) {
      this.playbackRegistration.unregister();
    }
  },
  methods: {
    onPlaybackStart() {
      if (this.playbackRegistration) {
        this.playbackRegistration.requestPlay();
      }
    },
    onPlaybackPause() {
      if (this.playbackRegistration) {
        this.playbackRegistration.markPaused();
      }
    },
    pausePlayer() {
      if (!this.plyrInstance || !this.plyrInstance.pause) return;
      try {
        this.plyrInstance.pause();
      } catch (e) {
        // Ignore provider timing errors while the iframe is initializing.
      }
    },
    onPlayerReady(event) {
      // Access the YouTube player instance
      this.playerInstance = event.detail; // YouTube player instance
      this.setHDQuality();
    },
    setHDQuality() {
      if (this.playerInstance && this.playerInstance.setPlaybackQuality) {
        // Set the desired quality level, 'hd1080' for 1080p or 'hd720' for 720p
        this.playerInstance.setPlaybackQuality('hd1080');
      }
    }
  },
};
</script>

<style>
.lesson-video-player,
.lesson-video-player .plyr {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
}

.lesson-video-player .plyr {
  overflow: hidden;
  border-radius: 12px;
}

.lesson-video-player iframe,
.lesson-video-player video {
  max-width: 100%;
}

.plyr__controls {
  background: #111;
  border-radius: 12px;
}
/* Add any styles here */
</style>
